import { actions } from "./Reducer";


export const getFavSupplierProductsAction = (customerId) => ({
  type: actions.GET_FAV_SUPPLIER_PRODUCTS,
  payload: customerId
})

export const getFavSupplierProductsSuccessAction = (body) => ({
  type: actions.GET_FAV_SUPPLIER_PRODUCTS_SUCCESS,
  payload: body
})


export const removeFavSupplierPoductAction = (customerId, productID) => ({
  type: actions.REM_FAV_SUPPLIER_PRODUCTS,
  payload: {
    customerId,
    productID
  }
})

export const removeFavSupplierProductSuccessAction = (productID) => ({
  type: actions.REM_FAV_SUPPLIER_PRODUCTS_SUCCESS,
  payload: productID
})


export const setCustomerFavSupplierProductsIsLoadingAction = (isLoading) => ({
  type: actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_IS_LOADING,
  payload: isLoading,
});

export const setCustomerFavSupplierProductsCountAction = (count) => ({
  type: actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_SEARCH_VALUE,
  payload: value,
});